import React from 'react';
import { MarginRightProps } from 'styled-system';

import { LogoImage } from './LogoImage';

export function AvatarImage({
  alt,
  'data-qa-id': dataQAId,
  handle,
  mimetype,
  initial,
  round = true,
  width = 64,
  mr,
}: MarginRightProps & {
  alt: string;
  'data-qa-id'?: string;
  handle?: string;
  mimetype?: string;
  initial?: string;
  round?: boolean;
  width?: number;
}) {
  return (
    <LogoImage
      width={width}
      height={width}
      handle={handle}
      initial={initial}
      alt={alt}
      data-qa-id={dataQAId}
      fit="crop"
      round={round}
      mimetype={mimetype}
      mr={mr}
    />
  );
}
